import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=724dbffa&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=724dbffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724dbffa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724dbffa')) {
      api.createRecord('724dbffa', component.options)
    } else {
      api.reload('724dbffa', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=724dbffa&scoped=true&", function () {
      api.rerender('724dbffa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/sale/Edit.vue"
export default component.exports